import { FileAttachment, TextDirection } from 'interface';

export interface __CameraProps {
    capture?: __CaptureType;
    label?: string;
    hint?: string;
    image?: FileAttachment;
    alt?: string;
    labelColor?: string;
    onChange?(e?: FileAttachment): void;
    onDrop?(): void;
    onRemove?(e?: FileAttachment): void;
    color?: string;
    defaultValue?: FileAttachment;
    required?: boolean;
    dir?: TextDirection;
    ws: number;
    counter?: number;
    accessToken?: string;
}

export interface __CameraRef {
    getValue: () => FileAttachment | undefined;
    setError: (text: string) => void;
}
export enum __CaptureType {
    user = 'user',
    environment = 'environment',
}
